import { render, staticRenderFns } from "./WtStatColumn.vue?vue&type=template&id=0158a083&scoped=true&lang=pug&"
import script from "./WtStatColumn.vue?vue&type=script&lang=js&"
export * from "./WtStatColumn.vue?vue&type=script&lang=js&"
import style0 from "./WtStatColumn.vue?vue&type=style&index=0&id=0158a083&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0158a083",
  null
  
)

export default component.exports